<template>
  <Modal
    :title="$t('add_new_attribute')"
    modalId="create-modal8"
    @submit="submitAttribute"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitAttribute">
      <div class="mb-3">
        <label class="form-label">
          {{ $t('attribute_name') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="attribute.name"
          class="form-control"
        />
        <div v-if="errors.name" class="text-danger mt-2">
          <span>{{ errors.name }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue";
import apiUrls from "@/urls";

export default {
  components: {
    Modal,
  },

  data() {
    return {
      attribute: {
        name: "",
      },
      errors: {},
      errorMessage: "",
    };
  },

  methods: {
    async submitAttribute() {
      this.errors = {};
      this.errorMessage = "";

      const name = this.attribute.name.trim();
      if (!name) {
        this.errors.name = this.$t("error.required");
        return;
      }

      try {
        await this.$axios.post(apiUrls.attribute.post, [{ name }]);

        // Fetch full attribute (with id/values) after create
        const listRes = await this.$axios.get(apiUrls.attribute.get);
        const created = (listRes.data || []).find(
          (a) => String(a.name).toLowerCase() === name.toLowerCase()
        );

        const modal = document.getElementById("create-modal8");
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        this.$emit("create_success", created || { name, values: [] });
        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        const apiErrors = error.response?.data?.errors || error.response?.data;
        if (Array.isArray(apiErrors) && apiErrors[0]?.name) {
          this.errors.name = Array.isArray(apiErrors[0].name)
            ? apiErrors[0].name[0]
            : apiErrors[0].name;
        } else if (apiErrors?.name) {
          this.errors.name = Array.isArray(apiErrors.name)
            ? apiErrors.name[0]
            : apiErrors.name;
        } else if (typeof error.response?.data?.detail === "string") {
          this.errorMessage = error.response.data.detail;
        }
      }
    },

    resetForm() {
      this.attribute.name = "";
      this.errors = {};
      this.errorMessage = "";
    },
  },
};
</script>
